// Single source for the legal identity shown in the footer, contact and legal pages.
export const COMPANY = {
  tradingName: 'IP9',
  legalName: 'KOKLACS LTD',
  companyNumber: '17449676',
  jurisdiction: 'England and Wales',
  addressLines: ['128 City Road', 'London', 'EC1V 2NX', 'United Kingdom'],
  address: '128 City Road, London, EC1V 2NX, United Kingdom',
  website: 'https://ip9.io',
  emails: {
    support: 'support@ip9.io',
    privacy: 'privacy@ip9.io',
    legal: 'legal@ip9.io',
    abuse: 'abuse@ip9.io',
  },
};

export const LEGAL_LAST_UPDATED = '19 October 2026';

export const LEGAL_PAGES = [
  { href: '/legal', label: 'Legal Notice' },
  { href: '/terms-of-service', label: 'Terms of Service' },
  { href: '/privacy-policy', label: 'Privacy Policy' },
  { href: '/cookie-policy', label: 'Cookie Policy' },
  { href: '/refund-policy', label: 'Refund & Cancellation Policy' },
  { href: '/acceptable-use-policy', label: 'Acceptable Use Policy' },
];
